import { useAuth0 } from '@auth0/auth0-react';
import { useCallback } from 'react';

import { MissingAccessTokenError } from '@/errors/MissingAccessTokenError';

/**
 * Wraps Auth0's getAccessTokenSilently, which can resolve with no token
 * (auth0-spa-js 2.25+ widened its return type to match runtime behaviour
 * that already existed). Callers need an actual token to make an
 * authenticated request, so this throws MissingAccessTokenError instead of
 * letting an empty token flow into a request.
 */
export const useAccessToken = () => {
  const { getAccessTokenSilently } = useAuth0();

  return useCallback(async () => {
    const token = await getAccessTokenSilently();
    if (!token) throw new MissingAccessTokenError('Auth0 did not return an access token');
    return token;
  }, [getAccessTokenSilently]);
};
